export const normalizeResidenceStatus = (value) => {
    if (!value) return '';
    return String(value)
        .trim()
        .replace(/\s/g, '')
        .replace(/２/g, '2')
        .replace(/１/g, '1');
};

export const isSpecifiedSkill2Status = (value) => (
    normalizeResidenceStatus(value) === '特定技能2号'
);

const toTime = (value) => {
    if (!value) return 0;
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? 0 : time;
};

// Sort a copy for display; keep undated entries last and equal dates stable.
export const sortRenewalEntriesNewestFirst = (entries = []) => (
    [...entries].sort((a, b) => toTime(b.renewalDate) - toTime(a.renewalDate))
);

export const getCurrentResidenceStatusFromEntries = (mainStatus, renewalEntries = []) => {
    const latestRenewal = (Array.isArray(renewalEntries) ? renewalEntries : [])
        .map((entry, index) => ({ entry, index }))
        .filter(({ entry }) => entry?.residenceStatus && String(entry.residenceStatus).trim() !== '')
        .slice()
        .sort((a, b) => {
            const effectiveDiff =
                toTime(b.entry.renewalGrantDate || b.entry.renewalDate) -
                toTime(a.entry.renewalGrantDate || a.entry.renewalDate);
            if (effectiveDiff !== 0) return effectiveDiff;

            const createdDiff = toTime(b.entry.createdAt) - toTime(a.entry.createdAt);
            if (createdDiff !== 0) return createdDiff;

            return b.index - a.index;
        })[0]?.entry;

    return latestRenewal?.residenceStatus || mainStatus || '';
};

export const getCurrentResidenceStatus = (residencePermit) => (
    getCurrentResidenceStatusFromEntries(
        residencePermit?.residenceStatus,
        residencePermit?.renewalEntries
    )
);

export const isSpecifiedSkill2Talent = (talent) => {
    if (typeof talent?.isSpecifiedSkill2 === 'boolean') {
        return talent.isSpecifiedSkill2;
    }

    return isSpecifiedSkill2Status(
        talent?.currentResidenceStatus ||
        getCurrentResidenceStatus(talent?.residencePermit || talent?.residence)
    );
};
